export const updateSaldo = (jumlah_saldo) => ({
    type: 'UPDATE_JUMLAH_SALDO',
    jumlah_saldo
})


// WEBPACK FOOTER //
// ./src/actions/saldoAction.js